import angular from 'angular';

class PrincipalOffreApiCtrl {
    /* @ngInject */
    constructor(PrincipalSvc, $location, $state, AuthSvc, logger, DocumentModelDA) {
        this.PrincipalSvc = PrincipalSvc;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.logger = logger;
        this.DocumentModelDA = DocumentModelDA;
        this.filteredOptions1 = [];
        this.filteredOptions2 = [];
        this.filteredOptions3 = [];
        this.FiltredAttributes = [];
    }

    $onInit() {
        // Indique si le formulaire est en cours de soumission
        this.isSubmitting = false;

        // reset OffreApiConfig
        this.resetoffresApiConfig = angular.copy(this.offresApiConfig);

        // Récupérer que les attributs de type texte et numérique
        this.FiltredAttributes = this.dictionnaireAttributs.filter(a => a.type === 'Number' || a.type === 'Text');

        /* Indique si disable ou non offre API */
        this.disableOffreApi = function () {
            return !this.hasGisPlatform() || !this.isEditAuthorized();
        };

        // Call the filtering functions initially to set up the initial options
        this.filterOptionsForSelector3();
        this.filterOptionsForSelector2();
        this.filterOptionsForSelector1();
    }

    /* Indique si le DO importé est paramétré sur la plateforme GIS*/
    hasGisPlatform() {
        return (
            this.principal.detail.dematPlatforms &&
            this.principal.detail.dematPlatforms.some(element => element.family === 'GIS')
        );
    }

    isInvoiceRetrievalActive(offreApiConfig) {
        return (this.isAnyInvoiceRetrieval(offreApiConfig)) && offreApiConfig.active;
    }

    isInvoiceRetrieval(offreApiConfig) {
        return offreApiConfig.offerApi.eid === 'INVOICE_RETRIEVAL';
    }

    isInvoiceRetrievalAfnor(offreApiConfig) {
        return offreApiConfig.offerApi.eid === 'INVOICE_RETRIEVAL_AFNOR';
    }

    isAnyInvoiceRetrieval(offreApiConfig) {
        return ['INVOICE_RETRIEVAL', 'INVOICE_RETRIEVAL_AFNOR'].includes(offreApiConfig.offerApi.eid);
    }

    isInvoiceUpdate(offreApiConfig) {
        return offreApiConfig.offerApi.eid === 'INVOICE_UPDATE';
    }

    isInvoiceSend(offreApiConfig) {
        return offreApiConfig.offerApi.eid === 'INVOICE_SEND';
    }

    shouldDisplayFilter(offreApiConfig) {
        return offreApiConfig.offerApi.filters && (this.isAnyInvoiceRetrieval(offreApiConfig));
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    getInvoiceRetrievalConfig() {
        return this.offresApiConfig.find(config => this.isInvoiceRetrieval(config));
    }

    onOfferApiChange(changedOffer) {
        if (changedOffer.active && (this.isAnyInvoiceRetrieval(changedOffer))) {
            this.offresApiConfig.forEach(offer => {
                if (offer !== changedOffer) {
                    if (this.isAnyInvoiceRetrieval(offer)) {
                        offer.active = false;
                    }
                }
            });
        }
    }

    shouldIndent(offreApiConfig) {
        const subCategories = [
            'INVOICE_RETRIEVAL',
            'INVOICE_RETRIEVAL_AFNOR',
            'STATUS_RETRIEVAL_AFNOR',
            'INVOICE_UPDATE',
            'INVOICE_UPDATE_AFNOR',
            'INVOICE_SEND',
            'INVOICE_SEND_AFNOR'
        ];
        return subCategories.includes(offreApiConfig.offerApi.eid);
    }

    // Function to filter options for Selector 3 based on the selection made in Selector 1 and 2
    filterOptionsForSelector3() {
        const offreApiConfig = this.getInvoiceRetrievalConfig();
        if (!offreApiConfig) return; // If no matching config found, return

        this.filteredOptions3 = this.FiltredAttributes.filter(item => {
            return item.path !== offreApiConfig.path1 && item.path !== offreApiConfig.path2;
        });

        // Reset automatique si valeur supprimée
        if (!offreApiConfig.path3) {
            offreApiConfig.value3 = null;
        }
    }

    // Function to filter options for Selector 2 based on the selection made in Selector 1 and 3
    filterOptionsForSelector2() {
        const offreApiConfig = this.getInvoiceRetrievalConfig();
        if (!offreApiConfig) return; // If no matching config found, return

        this.filteredOptions2 = this.FiltredAttributes.filter(item => {
            return item.path !== offreApiConfig.path1 && item.path !== offreApiConfig.path3;
        });

        // Reset automatique si valeur supprimée
        if (!offreApiConfig.path2) {
            offreApiConfig.value2 = null;
        }
    }

    // Function to filter options for Selector 1 based on the selection made in Selector 2 and 3
    filterOptionsForSelector1() {
        const offreApiConfig = this.getInvoiceRetrievalConfig();
        if (!offreApiConfig) return; // If no matching config found, return

        this.filteredOptions1 = this.FiltredAttributes.filter(item => {
            return item.path !== offreApiConfig.path2 && item.path !== offreApiConfig.path3;
        });

        // Reset automatique si valeur supprimée
        if (!offreApiConfig.path1) {
            offreApiConfig.value1 = null;
        }
    }

    back() {
        this.$state.go('do', { tabName: 'principal' });
    }
    cancel() {
        this.offresApiConfig = angular.copy(this.resetoffresApiConfig);
    }

    sendOffer() {
        if (this.form.$valid && !this.isSubmitting) {
            this.isSubmitting = true;
            this.PrincipalSvc.addOfferApi(this.PrincipalSvc.getPrincipalId(), this.offresApiConfig).then(
                data => {
                    this.form.$setPristine();
                    this.logger.success('success.update', data, null, { entityName: "Le Donneur d'ordre" });
                    this.isSubmitting = false;
                    // récupérer les données de la base de données
                    this.offresApiConfig = data;
                },
                error => {
                    this.logger.error('error.update', error);
                    this.isSubmitting = false;
                }
            );
        }
    }
}

angular.module('app.principal').component('principalOffreApi', {
    templateUrl: require('./principal-offreApi.html'),
    controller: PrincipalOffreApiCtrl,
    bindings: {
        principal: '<',
        functionalType: '<',
        dictionnaireAttributs: '<',
        offresApiConfig: '<',
    },
});
